import { Link } from "react-router-dom";
import { useState } from "react";

export default function ArticleCard({ article, onOpen }) {
  const [imgError, setImgError] = useState(false);
  const [imgLoading, setImgLoading] = useState(true);

  const imageBaseUrl = "http://localhost:5452/uploads/artigos/";
  
  function getImageUrl(){
    if (!article.image || imgError) {
      return "https://via.placeholder.com/400x300?text=Sem+Imagem";
    }
    
    // Remove barras extras se existirem
    const cleanImagePath = article.image.replace(/^\//, '');
    return `${imageBaseUrl}${cleanImagePath}`;
  };

  const imageUrl = getImageUrl();

  function handleImageError() {
    console.error(`Erro ao carregar imagem: ${imageUrl}`);
    setImgError(true);
    setImgLoading(false);
  };

  function handleImageLoad() {
    setImgLoading(false);
  };

  function description(text, maxLength) {
    if (!text) return "Sem descrição disponível";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  }

  return (
    <div className="rounded-xl shadow-md overflow-hidden bg-white hover:shadow-lg transition flex flex-col">
      <div className="relative w-full h-48 bg-gray-200">
        {imgLoading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          </div>
        )}
        <img
          src={imageUrl}
          alt={article.title || "Artigo sem título"}
          className={`w-full h-48 object-cover ${imgLoading ? 'opacity-0' : 'opacity-100'}`}
          onError={handleImageError}
          onLoad={handleImageLoad}
        />
      </div>
      
      <div className="p-4 flex flex-col flex-grow">
        <Link
          to={`/posts/${article.id}`}
          className="text-xl font-semibold text-gray-950 hover:underline no-underline"
        >
          {article.title || "Título não disponível"}
        </Link>
        
        <p className="text-gray-600 text-sm mt-4">
          {description(article.content || "", 80)}
        </p>
        
        <div className="text-gray-600 text-sm mt-2">
          <p className="mb-0">
            {article.created_at 
              ? new Date(article.created_at).toLocaleDateString("pt-BR")
              : "Data não disponível"
            }
          </p>
          <p>
            postado por: {article.usuario?.nome || "N/A"} {article.usuario?.sobrenome || ""}
          </p>
        </div>
        
        <div className="mt-auto">
          <button
            onClick={() => onOpen(article)}
            className="mt-4 text-sm text-white bg-blue-500 px-3 py-1 rounded hover:bg-blue-600"
          >
            Ler Mais
          </button>
        </div>
      </div>
    </div>
  );
}